module.exports = __webpack_public_path__ + "media/bootstrap-icons/gift-8e1e2d56.svg";